import request from "./request";
import { IRequest } from "@/shared/types/request";
import { IUsers, IUser, IMe } from "@/shared/types/users";

export const getMe = () => request.get<never, IMe>("/users/me");

export const getUsers = (params: { page: number; email: string }) =>
  request.get<never, IRequest<IUsers>>("/users", { params });

export const getUser = (id: string) =>
  request.get<never, IRequest<IUser>>(`/users/${id}`);

export const toggleVip = (payload: { user_uuid: string }) =>
  request.post<never, IRequest<IUsers>>(`/toggle-vip-subscription`, payload);

export const createComment = (field: { comment: string; user_uuid: string }) =>
  request.post<never, IRequest<IUsers>>(`/comments/`, field);

export const refreshUser = (payload: { user_uuid: string }) =>
  request.post<never, IRequest<boolean>>(`/refresh-subscriptions`, payload);
